export type errorsTerzo = "nameError" | "lastNameError" | "fiscalCodeError" | "genderError" | "dateOfBirthError" | "countryOfBirthError" | "cityOfBirthError" | "emailError" | "streetError" | "streetNumberError" | "cityError" | "zipCodeError" | "countryError" | "CodiceFiscaleError";

export const parseErrors = {
    "nameError":"name",
    "lastNameError":"lastName",
    "fiscalCodeError":"fiscalCode",
    "genderError":"gender",
    "dateOfBirthError":"dateOfBirth",
    "countryOfBirthError":"countryOfBirth",
    "cityOfBirthError":"cityOfBirth",
    "emailError":"email",
    "streetError":"street",
    "streetNumberError":"streetNumber",
    "cityError":"city",
    "zipCodeError":"zipCode",
    "countryError":"country",
    "CodiceFiscaleError": "fiscalCode"
};

/**
 * Campos del terzo referente que se exigen antes de guardar. El camino native
 * (gateway → ms-agl) solo valida el codice fiscale en servidor: sin esto, un
 * referente se guardaba sin país de nacimiento y AGL lo recibía vacío (03-11-2026).
 * Devuelve el campo que falta, o null.
 */
export const missingTerzoField = (terzo: { countryOfBirth?: string | null }): "countryOfBirth" | null =>
    (terzo.countryOfBirth ?? "").trim() === "" ? "countryOfBirth" : null;

export const beneficiariesOptions = [
    {
        value: "Legal heirs",
        label: "questions.beneficiaries.legal"
    },
    {
        value: "My children",
        label: "questions.beneficiaries.children"
    },
    {
        value: "Testament heirs",
        label: "questions.beneficiaries.testament"
    },
    {
        value: "My spouse",
        label: "questions.beneficiaries.spouse"
    },
    {
        value: "Free designation",
        label: "questions.beneficiaries.freeDesignation"
    }
];

export const optionsTerzo = [
    {
        value: "yes",
        text: "Sì",
        label: "Sì",
    },
    {
        value: "no",
        text: "No",
        label: "No",
    },
];